import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";

const Login = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const history = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [login, setLogin] = useState({ 
        email: '',
        password: ''
    });
    const { email, password } = login;

    const handleInput = (e) => {
        setLogin({ ...login, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
            const response = await axios.post('https://pastq.eddcodesgh.com/qApi/admin/auth/_login.php', login, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer f0ed28e67f2a90c8bf437f1ff949ef23655e842a2901b7b87779673a0d176506",
                },
                withCredentials: true,
            });
            if (response.data.status == 200) {
                toast.success(response.data.message);
                localStorage.setItem("userToken", response.data.userToken);
                localStorage.setItem("email", response.data.email);
                history('/dashboard');
            } else {
                toast.error( response.data.message);
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };
  
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="">
      <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
             
              {/* Login Card */}
              <div className="card mb-3 shadow-lg rounded" style={{border: 'none'}}>
                <div className="card-body ">
                  <p className="text-center ">Admin Only</p>
                  <form className="row g-3 needs-validation" onSubmit={handleSubmit} noValidate>
                    {/* Username Field */}
                    <div className="col-12">
                      <label htmlFor="yourUsername" className="form-label fw-semibold">Username</label>
                      <div className="input-group has-validation">
                        <span className="input-group-text bg-light border-end-0">
                          <i className="bi bi-person text-secondary"></i>
                        </span>
                        <input 
                          type="text" 
                          name="email" 
                          className="form-control border-start-0" 
                          id="yourUsername" 
                          value={email}
                          onChange={handleInput}
                          required 
                          placeholder="Enter your username"
                        />
                        <div className="invalid-feedback">Please enter your username.</div>
                      </div>
                    </div>

                    {/* Password Field with Toggle */}
                    <div className="col-12">
                      <label htmlFor="yourPassword" className="form-label fw-semibold">Password</label>
                      <div className="input-group has-validation">
                        <span className="input-group-text bg-light border-end-0">
                          <i className="bi bi-lock text-secondary"></i>
                        </span>
                        <input 
                          type={passwordVisible ? "text" : "password"} 
                          name="password"
                          value={password}
                          onChange={handleInput} 
                          className="form-control border-start-0 pe-5" 
                          id="yourPassword" 
                          required 
                          placeholder="Enter your password"
                        />
                        <span 
                          className="position-absolute end-0 top-50 translate-middle-y me-3"
                          style={{cursor: 'pointer', zIndex: 5}}
                          onClick={togglePasswordVisibility}
                        >
                          <i className={`bi ${passwordVisible ? 'bi-eye-slash' : 'bi-eye'} text-muted`}></i>
                        </span>
                        <div className="invalid-feedback">Please enter your password!</div>
                      </div>
                    </div>

                    {/* Login Button */}
                    <div className="col-12">
                        <button
                            className="btn btn w-100 text-white py-2 fw-semibold" style={{ background: "#096b00" }} type="submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <span className="spinner-border text-white spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Sending...
                                </>
                            ) : (
                                'Login'
                            )}
                        </button>

                       
                    </div>
                     <Link to="/" className="mt-4">Back to Home</Link>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      
    
    </div>
  );
};

export default Login;